export default {
  HG_1021_STATE_TCPA_WELCOME_FLOW: 'HG-1021-State-TCPA-WelcomeFlow-Legal',
  TECHNOLOGY_FEE: 'HG-4020-Technology-Fee',
};
